export default {
  name: '我是杰',
  login: {
    userName: '用户名',
    password: '密码',
    message: '请输入你的',
    btn: '登录',
  },
  user: {
    name: '管理员',
  },
};
